<!-- <mat-toolbar id="toolbar" class="mat-elevation-z3" style="position:sticky;top:0px;z-index:2;background-color:#FFF;">
  <mat-toolbar-row>
    <ng-container *ngIf="authenticatedUser$ | async as authenticatedUser">
      <button style="height:36px;width:36px;" mat-icon-button>
        <sha-avatar [avatarUrl]="authenticatedUser.user.avatarUrl"
          [initials]="[authenticatedUser.user.firstName.charAt(0) + authenticatedUser.user.lastName.charAt(0)]">
        </sha-avatar>
      </button>
    </ng-container>
    <span fxFlex style="margin-left: 12px;">Maintenance Menu {{readOnly ? '(Read Only)' : ''}}</span>

  </mat-toolbar-row>
</mat-toolbar> -->

<div *ngIf="{labourOpData: $labourOpData | async, gmSltData: gmSltData$ | async,
    loadProblems: menuLoadProblems$ | async} as data" fxLayout="row"
  style="margin:16px;" fxLayoutAlign="center start">
  <div fxLayout="row" fxFlex class="content" fxLayoutAlign="space-between start">
    <div fxLayout="column" fxFlex="70" [@flyOutIn]="dank">
      <div fxLayout="row" fxFlexAlign="center" fxLayoutAlign="center center" class="mat-elevation-z1"
        style="width:80%;padding:16px;background-color:#FFF;border-radius:8px;"
        *ngIf="$vehicle | async as vehicle;else loadingVehicle">
        <div fxLayout="row" fxLayoutAlign="start center" style="width:100%;">
          <div style="height:36px;width:36px;border-radius:50%;background-color:#9E9E9E;color:#FFF;"
            fxLayoutAlign="center center">
            <mat-icon aria-label="Car icon">directions_car</mat-icon>
          </div>
          <div fxLayout="column" fxFlex fxLayoutAlign="center start" style="padding-left:16px;">
            <span class="mat-subheading-2" style="margin-bottom:0;">{{vehicle.year}} {{vehicle.make}}
              {{vehicle.model}}</span>
            <span class="mat-body-1 secondary-text">{{vehicle.currentMileage}}{{mileageLabel}}</span>
            <span *ngIf="quote" class="mat-body-1 secondary-text">Quote #{{quote.id}}</span>
          </div>
        </div>
      </div>

      <ng-template #loadingVehicle>
        <div fxLayout="column" fxFlexAlign="center" fxLayoutAlign="center center" class="mat-elevation-z1"
          style="width:80%;padding:16px;background-color:#FFF;border-radius:8px;">
          <div fxLayout="row" fxLayoutAlign="start center" style="width:100%;">
            <div style="height:36px;width:36px;border-radius:50%;background-color:#9E9E9E;color:#FFF;"
              fxLayoutAlign="center center">
              <mat-icon aria-label="Car icon">directions_car</mat-icon>
            </div>
            <div fxLayout="column" fxLayoutAlign="center start" fxFlex style="padding-left:16px;">
              <span class="animated-background"
                style="height:15px;width:80%;margin:6px 0 6px 0;border-radius:4px;"></span>
              <span class="animated-background"
                style="height:15px;width:80%;margin:6px 0 6px 0;border-radius:4px;"></span>
            </div>
          </div>
        </div>
      </ng-template>

      <div style="margin:24px 8px 0px 8px;" fxLayoutAlign="space-between center">
        <h2>Services</h2>
        <div fxLayout="start center">
          <span>Only Show Due</span>
          <mat-slide-toggle [disabled]="readOnly" color="primary" [checked]="true" (change)=sliderChanged($event)
            style="margin-left:8px;">
          </mat-slide-toggle>
        </div>
      </div>

      <ng-container *ngIf="!data.loadProblems?.length; else menuUnavailable">
      <div style="margin:8px 8px 8px 8px;" fxLayoutAlign="space-between center">
        <span class="mat-subheading-2" style="font-weight:500;">Factory Required Services</span>
        <button mat-icon-button style="margin-right:4px;"
          (click)="toggleCollapse(factoryRequiredServices, factoryRequiredServicesUi)">
          <mat-icon>{{factoryRequiredServicesUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
          </mat-icon>
        </button>
      </div>

      <ng-container *ngIf="factoryRequiredServices; else loading">
        <div fxLayout="column"
          *ngFor="let menuItem of factoryRequiredServices | orderBy: ['frequencyMileage','dueDate','displayServiceGroup.name']"
          class="testing-concept" class="mat-elevation-z1"
          style="overflow:hidden;page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;">
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <div fxLayout="column">
              <div fxLayoutAlign="start center">
                <button mat-icon-button style="margin-right:4px;" (click)="menuItem.collapsed = !menuItem.collapsed">
                  <mat-icon>{{menuItem.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</mat-icon>
                </button>
                <h3 class="mat-body-2">
                  {{menuItem.displayServiceGroup.name}}</h3>
              </div>
              <h4 class="mat-body-1 secondary-text">Due {{menuItem.dueDate| date}} {{menuItem.dueBy}}
                ({{menuItem.frequencyMileage}}{{mileageLabel}} or {{menuItem.frequencyMonths}} months) </h4>

              <div *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup)" fxLayout="row"
                fxLayoutAlign="start center">
                <div class="accepted-service"></div>
                <span class="mat-caption secondary-text">Accepted on current transaction</span>
              </div>
              <div *ngIf="checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup)" fxLayout="row"
                fxLayoutAlign="start center">
                <div class="declined-service"></div>
                <span class="mat-caption secondary-text">Declined on current transaction</span>
              </div>

            </div>
            <div *ngIf="data.labourOpData?.serviceGroupRates; else loadPricing">
              <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag !== 'M'">
                {{getPrice(menuItem.displayServiceGroup,
                data.labourOpData.serviceGroupRates) | currency}}</h3>
              <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag === 'M'">N/A</h3>
            </div>
            <ng-template #loadPricing>
              <h3 class="animated-background" style="height:20px;width:26px;margin:5px 0 5px 0;border-radius:4px;"></h3>
            </ng-template>
          </div>
          <ng-container *ngIf="!menuItem.collapsed">
            <ul *ngIf="data.labourOpData?.services;else loadingServices">
              <li *ngFor="let service of menuItem.displayServiceGroup.services" [@fadeInOut]
                class="mat-body-1 secondary-text">{{data.labourOpData.services[service].name}}</li>
            </ul>
            <ng-template #loadingServices>
              <ul>
                <li class="animated-background secondary-text"
                  style="height:14px;width:60%;margin:5px 0 5px 0;border-radius:4px;"></li>
                <li class="animated-background secondary-text"
                  style="height:14px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></li>
              </ul>
            </ng-template>
          </ng-container>
          <mat-divider style="margin:8px -16px 8px -16px"></mat-divider>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
              <button mat-icon-button
                [disabled]="menuItem.serviceGroup.useFlag !== 'M' || checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup) || checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup) || readOnly"
                (click)="selectService(menuItem, data.labourOpData.serviceGroups, data.labourOpData.serviceGroupRates)">
                <mat-icon>view_list</mat-icon>
              </button>
              <button mat-icon-button [disabled]="getRoHistory(roHistory,menuItem) || readOnly"
                (click)="viewRoHistory(roHistory, menuItem)">
                <mat-icon>history</mat-icon>
              </button>
              <button mat-icon-button [disabled]="menuItem.displayServiceGroup.salesHint == null || readOnly"
                (click)="viewSalesHint(menuItem.displayServiceGroup.salesHint)">
                <mat-icon>help</mat-icon>
              </button>
            </div>

            <div
              *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup) || checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup); else pendingButtons">
              <button mat-icon-button [disabled]="readOnly" *ngIf="authenticatedUser$ | async as authenticatedUser"
                mat-icon-button
                (click)="acceptServiceOnQuote(menuItem.displayServiceGroup, data.labourOpData, authenticatedUser.user.xselleratorEmployeeId)">
                <mat-icon>add_circle_outline</mat-icon>
              </button>

              <button mat-icon-button [disabled]="true">
                <mat-icon>clear</mat-icon>
              </button>

              <button mat-icon-button [disabled]="true">
                <mat-icon>check</mat-icon>
              </button>
            </div>
            <ng-template #pendingButtons>
              <div>
                <ng-container *ngIf="!checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup);">
                  <button mat-icon-button [disabled]="readOnly" *ngIf="authenticatedUser$ | async as authenticatedUser"
                    mat-icon-button
                    (click)="acceptServiceOnQuote(menuItem.displayServiceGroup, data.labourOpData, authenticatedUser.user.xselleratorEmployeeId)">
                    <mat-icon>add_circle_outline</mat-icon>
                  </button>

                  <button mat-icon-button [disabled]="readOnly"
                    *ngIf="checkServiceGroupStatus('pending-declined', menuItem.displayServiceGroup); else removeButton"
                    (click)="removeDeclinedService(menuItem, data.labourOpData.quoteLines, data.gmSltData)"
                    style="color:#C62828">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                  <ng-template #removeButton>
                    <button mat-icon-button [disabled]="menuItem.displayServiceGroup.useFlag === 'M' || readOnly"
                      (click)="selectDeclinedReason(menuItem, declinedReasons, data.labourOpData, data.gmSltData)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M'">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>

                <ng-container *ngIf="!checkServiceGroupStatus('pending-declined', menuItem.displayServiceGroup);">

                  <button mat-icon-button [disabled]="readOnly || (disableRemoveServiceButton$ | async)"
                    *ngIf="checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup); else addButton"
                    (click)="removeAcceptedService(menuItem, data.labourOpData.quoteLines, data.gmSltData)"
                    style="color:#2E7D32">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                  <ng-template #addButton>

                    <button mat-icon-button (click)="acceptService(menuItem, data.labourOpData, data.gmSltData)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M' || readOnly">
                      <mat-icon>check</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-container>

      <div style="margin:8px 8px 8px 8px;" fxLayoutAlign="space-between center">
        <span class="mat-subheading-2" style="font-weight:500;">Factory Recommended Services</span>
        <button mat-icon-button style="margin-right:4px;"
          (click)="toggleCollapse(factoryRecommendedServices, factoryRecommendedServicesUi)">
          <mat-icon>{{factoryRecommendedServicesUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
          </mat-icon>
        </button>
      </div>

      <ng-container *ngIf="factoryRecommendedServices; else loading">
        <div fxLayout="column"
          *ngFor="let menuItem of factoryRecommendedServices | orderBy: ['frequencyMileage','dueDate','displayServiceGroup.name']"
          class="testing-concept" class="mat-elevation-z1"
          style="overflow:hidden;page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;">
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <div fxLayout="column">
              <div fxLayoutAlign="start center">
                <button mat-icon-button style="margin-right:4px;" (click)="menuItem.collapsed = !menuItem.collapsed">
                  <mat-icon>{{menuItem.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</mat-icon>
                </button>
                <h3 class="mat-body-2">{{menuItem.displayServiceGroup.name}}</h3>
              </div>
              <h4 class="mat-body-1 secondary-text">Due {{menuItem.dueDate| date}} {{menuItem.dueBy}}
                ({{menuItem.frequencyMileage}}{{mileageLabel}} or {{menuItem.frequencyMonths}} months) </h4>
              <div *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup)" fxLayout="row"
                fxLayoutAlign="start center">
                <div class="accepted-service"></div>
                <span class="mat-caption secondary-text">Accepted on current transaction</span>
              </div>
              <div *ngIf="checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup)" fxLayout="row"
                fxLayoutAlign="start center">
                <div class="declined-service"></div>
                <span class="mat-caption secondary-text">Declined on current transaction</span>
              </div>

            </div>
            <div *ngIf="data.labourOpData?.serviceGroupRates; else loadPricing">
              <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag !== 'M'">
                {{getPrice(menuItem.displayServiceGroup,
                data.labourOpData.serviceGroupRates) | currency}}</h3>
              <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag === 'M'">N/A</h3>
            </div>
            <ng-template #loadPricing>
              <h3 class="animated-background" style="height:18px;width:26px;margin:5px 0 5px 0;border-radius:4px;"></h3>
            </ng-template>
          </div>
          <ng-container *ngIf="!menuItem.collapsed">
            <ul *ngIf="data.labourOpData?.services;else loadingServices">
              <li *ngFor="let service of menuItem.displayServiceGroup.services" [@fadeInOut]
                class="mat-body-1 secondary-text">{{data.labourOpData.services[service].name}}</li>
            </ul>
          </ng-container>
          <ng-template #loadingServices>
            <ul>
              <li class="animated-background secondary-text"
                style="height:14px;width:60%;margin:5px 0 5px 0;border-radius:4px;"></li>
              <li class="animated-background secondary-text"
                style="height:14px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></li>
            </ul>
          </ng-template>
          <mat-divider style="margin:8px -16px 8px -16px"></mat-divider>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
              <button mat-icon-button
                [disabled]="menuItem.serviceGroup.useFlag !== 'M' || checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup) || checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup) || readOnly"
                (click)="selectService(menuItem, data.labourOpData.serviceGroups, data.labourOpData.serviceGroupRates)">
                <mat-icon>view_list</mat-icon>
              </button>
              <button mat-icon-button [disabled]="getRoHistory(roHistory,menuItem) || readOnly"
                (click)="viewRoHistory(roHistory, menuItem)">
                <mat-icon>history</mat-icon>
              </button>
              <button mat-icon-button [disabled]="menuItem.displayServiceGroup.salesHint == null || readOnly"
                (click)="viewSalesHint(menuItem.displayServiceGroup.salesHint)">
                <mat-icon>help</mat-icon>
              </button>
            </div>

            <div
              *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup) || checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup); else pendingButtons">
              <button mat-icon-button [disabled]="readOnly" *ngIf="authenticatedUser$ | async as authenticatedUser"
                mat-icon-button
                (click)="acceptServiceOnQuote(menuItem.displayServiceGroup, data.labourOpData, authenticatedUser.user.xselleratorEmployeeId)">
                <mat-icon>add_circle_outline</mat-icon>
              </button>
              <button mat-icon-button [disabled]="true">
                <mat-icon>clear</mat-icon>
              </button>

              <button mat-icon-button [disabled]="true">
                <mat-icon>check</mat-icon>
              </button>
            </div>
            <ng-template #pendingButtons>
              <div>
                <ng-container *ngIf="!checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup);">
                  <button mat-icon-button [disabled]="readOnly" *ngIf="authenticatedUser$ | async as authenticatedUser"
                    mat-icon-button
                    (click)="acceptServiceOnQuote(menuItem.displayServiceGroup, data.labourOpData, authenticatedUser.user.xselleratorEmployeeId)">
                    <mat-icon>add_circle_outline</mat-icon>
                  </button>

                  <button mat-icon-button [disabled]="readOnly"
                    *ngIf="checkServiceGroupStatus('pending-declined', menuItem.displayServiceGroup); else removeButton"
                    (click)="removeDeclinedService(menuItem, data.labourOpData.quoteLines, data.gmSltData)"
                    style="color:#C62828">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                  <ng-template #removeButton>
                    <button mat-icon-button [disabled]="menuItem.displayServiceGroup.useFlag === 'M' || readOnly"
                      (click)="selectDeclinedReason(menuItem, declinedReasons, data.labourOpData, data.gmSltData)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M' || !(data.labourOpData.serviceGroupRates[menuItem.displayServiceGroup.serviceGroupRateId] && data.labourOpData.serviceGroupRates[menuItem.displayServiceGroup.serviceGroupRateId].rate)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>

                <ng-container *ngIf="!checkServiceGroupStatus('pending-declined', menuItem.displayServiceGroup);">

                  <button mat-icon-button [disabled]="readOnly || (disableRemoveServiceButton$ | async)"
                    *ngIf="checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup); else addButton"
                    (click)="removeAcceptedService(menuItem, data.labourOpData.quoteLines, data.gmSltData)"
                    style="color:#2E7D32">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                  <ng-template #addButton>

                    <button mat-icon-button (click)="acceptService(menuItem, data.labourOpData, data.gmSltData)"
                      [disabled]="readOnly || menuItem.displayServiceGroup.useFlag === 'M'">
                      <mat-icon>check</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-container>

      <div style="margin:8px 8px 8px 8px;" fxLayoutAlign="space-between center">
        <span class="mat-subheading-2" style="font-weight:500;">Dealer Recommended Services</span>
        <button mat-icon-button style="margin-right:4px;"
          (click)="toggleCollapse(dealerRecommendedServices, dealerRecommendedServicesUi)">
          <mat-icon>{{dealerRecommendedServicesUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
          </mat-icon>
        </button>
      </div>
      <ng-container *ngIf="dealerRecommendedServices; else loading">
        <div fxLayout="column"
          *ngFor="let menuItem of dealerRecommendedServices | orderBy: ['frequencyMileage','dueDate','displayServiceGroup.name']"
          class="testing-concept" class="mat-elevation-z1"
          style="overflow:hidden;page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;">
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <div fxLayout="column">
              <div fxLayoutAlign="start center">
                <button mat-icon-button style="margin-right:4px;" (click)="menuItem.collapsed = !menuItem.collapsed">
                  <mat-icon>{{menuItem.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</mat-icon>
                </button>
                <h3 class="mat-body-2">{{menuItem.displayServiceGroup.name}}</h3>
              </div>
              <h4 class="mat-body-1 secondary-text">Due {{menuItem.dueDate| date}} {{menuItem.dueBy}}
                ({{menuItem.frequencyMileage}}{{mileageLabel}} or {{menuItem.frequencyMonths}} months) </h4>
              <div *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup)" fxLayout="row"
                fxLayoutAlign="start center">
                <div class="accepted-service"></div>
                <span class="mat-caption secondary-text">Accepted on current transaction</span>
              </div>
              <div *ngIf="checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup)" fxLayout="row"
                fxLayoutAlign="start center">
                <div class="declined-service"></div>
                <span class="mat-caption secondary-text">Declined on current transaction</span>
              </div>

            </div>
            <div *ngIf="data.labourOpData?.serviceGroupRates; else loadPricing">
              <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag !== 'M'">
                {{getPrice(menuItem.displayServiceGroup,
                data.labourOpData.serviceGroupRates) | currency}}</h3>
              <h3 class="mat-body-1 secondary-text" *ngIf="menuItem.displayServiceGroup.useFlag === 'M'">N/A</h3>
            </div>
            <ng-template #loadPricing>
              <h3 class="animated-background" style="height:18px;width:26px;margin:5px 0 5px 0;border-radius:4px;"></h3>
            </ng-template>
          </div>
          <ng-container *ngIf="!menuItem.collapsed">
            <ul *ngIf="data.labourOpData?.services;else loadingServices">
              <li *ngFor="let service of menuItem.displayServiceGroup.services" [@fadeInOut]
                class="mat-body-1 secondary-text">{{data.labourOpData.services[service].name}}</li>
            </ul>
          </ng-container>
          <ng-template #loadingServices>
            <ul>
              <li class="animated-background secondary-text"
                style="height:14px;width:60%;margin:5px 0 5px 0;border-radius:4px;"></li>
              <li class="animated-background secondary-text"
                style="height:14px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></li>
            </ul>
          </ng-template>
          <mat-divider style="margin:8px -16px 8px -16px"></mat-divider>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
              <button mat-icon-button
                [disabled]="menuItem.serviceGroup.useFlag !== 'M' || checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup) || checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup) || readOnly"
                (click)="selectService(menuItem, data.labourOpData.serviceGroups, data.labourOpData.serviceGroupRates)">
                <mat-icon>view_list</mat-icon>
              </button>
              <button mat-icon-button [disabled]="getRoHistory(roHistory,menuItem) || readOnly"
                (click)="viewRoHistory(roHistory, menuItem)">
                <mat-icon>history</mat-icon>
              </button>
            </div>

            <div
              *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.displayServiceGroup) || checkServiceGroupStatus('saved-declined', menuItem.displayServiceGroup); else pendingButtons">
              <button mat-icon-button [disabled]="readOnly" *ngIf="authenticatedUser$ | async as authenticatedUser"
                mat-icon-button
                (click)="acceptServiceOnQuote(menuItem.displayServiceGroup, data.labourOpData, authenticatedUser.user.xselleratorEmployeeId)">
                <mat-icon>add_circle_outline</mat-icon>
              </button>
              <button mat-icon-button [disabled]="true">
                <mat-icon>clear</mat-icon>
              </button>

              <button mat-icon-button [disabled]="true">
                <mat-icon>check</mat-icon>
              </button>
            </div>
            <ng-template #pendingButtons>
              <div>
                <ng-container *ngIf="!checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup);">
                  <button mat-icon-button [disabled]="readOnly" *ngIf="authenticatedUser$ | async as authenticatedUser"
                    mat-icon-button
                    (click)="acceptServiceOnQuote(menuItem.displayServiceGroup, data.labourOpData, authenticatedUser.user.xselleratorEmployeeId)">
                    <mat-icon>add_circle_outline</mat-icon>
                  </button>
                  <button mat-icon-button [disabled]="readOnly"
                    *ngIf="checkServiceGroupStatus('pending-declined', menuItem.displayServiceGroup); else removeButton"
                    (click)="removeDeclinedService(menuItem, data.labourOpData.quoteLines, data.gmSltData)"
                    style="color:#C62828">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                  <ng-template #removeButton>
                    <button mat-icon-button [disabled]="menuItem.displayServiceGroup.useFlag === 'M' || readOnly"
                      (click)="selectDeclinedReason(menuItem, declinedReasons, data.labourOpData, data.gmSltData)"
                      [disabled]="menuItem.displayServiceGroup.useFlag === 'M' || !(data.labourOpData.serviceGroupRates[menuItem.displayServiceGroup.serviceGroupRateId] && data.labourOpData.serviceGroupRates[menuItem.displayServiceGroup.serviceGroupRateId].rate)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>

                <ng-container *ngIf="!checkServiceGroupStatus('pending-declined', menuItem.displayServiceGroup);">

                  <button mat-icon-button [disabled]="readOnly || (disableRemoveServiceButton$ | async)"
                    *ngIf="checkServiceGroupStatus('pending-accepted', menuItem.displayServiceGroup); else addButton"
                    (click)="removeAcceptedService(menuItem, data.labourOpData.quoteLines, data.gmSltData)"
                    style="color:#2E7D32">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                  <ng-template #addButton>

                    <button mat-icon-button (click)="acceptService(menuItem, data.labourOpData, data.gmSltData)"
                      [disabled]="readOnly || menuItem.displayServiceGroup.useFlag === 'M'">
                      <mat-icon>check</mat-icon>
                    </button>
                  </ng-template>
                </ng-container>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-container>
      </ng-container>

      <ng-template #menuUnavailable>
        <div class="flex flex-col items-center py-12 text-center">
          <mat-icon class="no-results-icon">build</mat-icon>
          <span class="mat-body-2">The maintenance menu can't be shown for this vehicle.</span>
          <ul class="list-none p-0 my-2">
            <li *ngFor="let problem of data.loadProblems" class="mat-body-1">{{problem}}</li>
          </ul>
          <span class="mat-body-1 secondary-text">Correct the setup in XSELLERATOR, then reopen the menu.</span>
        </div>
      </ng-template>

      <ng-template #loading>
        <div class="mat-elevation-z1"
          style="page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;"
          *ngFor="let placeholder of [1,2,3,4]">
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <h3 class="animated-background" style="height:20px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></h3>
            <h3 class="animated-background" style="height:18px;width:26px;margin:5px 0 5px 0;border-radius:4px;"></h3>
          </div>
          <h3 class="animated-background" style="height:20px;width:30%;margin:5px 0 5px 0;border-radius:4px;"></h3>
          <ul style="margin:20px 0 12px 0;">
            <li class="animated-background secondary-text"
              style="height:14px;width:60%;margin:5px 0 5px 0;border-radius:4px;"></li>
            <li class="animated-background secondary-text"
              style="height:14px;width:40%;margin:5px 0 5px 0;border-radius:4px;"></li>
          </ul>
          <mat-divider style="margin:8px -16px 8px -16px"></mat-divider>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
              <button mat-icon-button [disabled]="true">
                <mat-icon>view_list</mat-icon>
              </button>
              <button mat-icon-button [disabled]="true">
                <mat-icon>history</mat-icon>
              </button>
            </div>
            <div>
              <button mat-icon-button [disabled]="true">
                <mat-icon>add_circle_outline</mat-icon>
              </button>
              <button mat-icon-button [disabled]="true">
                <mat-icon>clear</mat-icon>
              </button>

              <button mat-icon-button [disabled]="true">
                <mat-icon>check</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <div id="totals-container" [@flyInOut]="dank" class="mat-elevation-z2"
      style="padding:16px 16px 8px 16px;position:sticky;top:80px;background-color:#FFF;border-radius:8px;"
      fxLayout="column">
      <div fxLayout="column" fxLayoutAlign="center start">
        <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom:4px;width:100%;">
          <h3 class="mat-body-2" style="margin-bottom:0;color:#0D47A1;">Service Totals</h3>
          <button mat-icon-button id="print-button" *ngIf="dank == 'shrink'" (click)="print()">
            <mat-icon>print</mat-icon>
          </button>
        </div>
        <span class="mat-subheading-2" style="margin-bottom:0;"
          *ngIf="dank == 'shrink' && $vehicle | async as vehicle ">{{vehicle.year}}
          {{vehicle.make}} {{vehicle.model}}</span>
        <mat-divider style="width:100%;margin:0px 0px 16px 0;"></mat-divider>
        <h4 style="margin-bottom:8px;font-weight:500;">Pending</h4>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlexFill>
          <span class="mat-body-1 secondary-text">Accepted Total</span>
          <span class="mat-body-1">{{this.getTotal(pendingAccepted, data.labourOpData.serviceGroupRates) |
            currency}}</span>
        </div>
        <ul *ngIf="dank == 'shrink' && pendingAccepted.length > 0">
          <li class="mat-body-1 secondary-text" *ngFor="let serviceGroup of pendingAccepted">{{serviceGroup.name}}</li>
        </ul>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlexFill>
          <span class="mat-body-1 secondary-text">Declined Total</span>
          <span class="mat-body-1">{{this.getTotal(pendingDeclined, data.labourOpData.serviceGroupRates) |
            currency}}</span>
        </div>
        <ul *ngIf="dank == 'shrink' && pendingDeclined.length > 0">
          <li class="mat-body-1 secondary-text" *ngFor="let serviceGroup of pendingDeclined">{{serviceGroup.name}}
            {{getDeclinedReason(serviceGroup)}}</li>
        </ul>

        <h4 style="margin:12px 0 8px 0;font-weight:500;">Saved</h4>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlexFill>
          <span class="mat-body-1 secondary-text">Accepted Total</span>
          <span class="mat-body-1">{{this.getTotal(savedAccepted, data.labourOpData.serviceGroupRates) |
            currency}}</span>
        </div>
        <ul *ngIf="dank == 'shrink' && savedAccepted.length > 0">
          <li class="mat-body-1 secondary-text" *ngFor="let serviceGroup of savedAccepted">{{serviceGroup.name}}</li>
        </ul>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlexFill>
          <span class="mat-body-1 secondary-text">Declined Total</span>
          <span class="mat-body-1">{{this.getTotal(savedDeclined, data.labourOpData.serviceGroupRates) |
            currency}}</span>
        </div>
        <ul *ngIf="dank == 'shrink' && savedDeclined.length > 0">
          <li class="mat-body-1 secondary-text" *ngFor="let serviceGroup of savedDeclined">{{serviceGroup.name}}</li>
        </ul>

        <span class="mat-body-1 tertiary-text" style="font-size:12px;margin-top:12px;">* Taxes and shop supplies are
          not included</span>
        <div *ngIf="saving" fxLayout="row" fxLayoutAlign="center start">
          <span class="mat-body-2">Saving...</span>
          <span fxFlex class="mat-body-1 tertiary-text"
            style="font-size:12px;margin-top:3px;">{{requestingPending}}</span>
        </div>
        <mat-progress-bar *ngIf="saving" mode="determinate" [value]="saveProgress"></mat-progress-bar>
      </div>
      <mat-divider style="width:100%;margin:8px 0 8px 0"></mat-divider>
      <div id="totals-container-actions" fxLayout="row" fxLayoutAlign="space-around center">
        <button mat-raised-button [disabled]="readOnly || !!data.loadProblems?.length" color="primary"
          *ngIf="dank === 'full'"
          (click)="toggleAnimation()" style="border-radius:20px;">Confirm</button>
        <button mat-button [disabled]="readOnly  || saving" *ngIf="dank == 'shrink'" (click)="toggleAnimation()"
          style="border-radius:20px;">Cancel</button>
        <button mat-raised-button [disabled]="readOnly  || saving" color="primary" *ngIf="dank === 'shrink'"
          (click)="save(pendingAccepted,pendingDeclined, data.labourOpData, vehicle, transaction, data.gmSltData, oem)"
          style="border-radius:20px;">Save</button>
      </div>

      <div id="signature-container" style="margin-top:120px;" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxFlex="40" fxLayout="column">
          <input disabled style="border:0; border-bottom:1px solid #000000d1;">
          <span class="mat-caption" style="color:#000000d1">Customer Signature</span>
        </div>
        <div fxFlex="40" fxLayout="column">
          <input disabled style="border:0; border-bottom:1px solid #000000d1;">
          <span class="mat-caption" style="color:#000000d1">Employee Signature</span>
        </div>
      </div>
    </div>
  </div>
</div>